import { Redirect } from "react-router";

export function NotFoundPage() {

    return <Redirect to="/auth" />
}
